/*~~~~~~~~~~~~~~~~~ Tushar 2025-09-15 Gid.:1345(CPOS)*/
import { Component, Inject, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { cellDef, CommonFilter, TableObject } from '../../common-services/models.service';
import { CPOSEnum, InputType } from '../../common-services/enum.service';
import { ExcelService } from "../../common-services/excel.service";
import { SnackBarService } from "../../common-services/snack-bar.service";
import { ConfirmationHeader } from '../../common-services/enum.service';
import { ButtonType } from '../../common-component/confirmation-popup/confirmation-popup.component';
import * as XLSX from 'xlsx';
import { SharedService } from '../../shared/shared.service';

export interface ColumnValidation {
  columnRule: string;
  criteria?: any;
  columnMessage: string;
}

export interface TableColumn {
  key: string;
  header: string;
  isDisplay: boolean;
  isExport: boolean;
  validate?: ColumnValidation[];
}

export interface DialogConfig {
  PageId: number;
  title: string;
  postApiUrl: string;
  fileDownloadName: string;
  tableColumns: TableColumn[];
}
@Component({
  selector: 'app-excel-data-dialog',
  templateUrl: './excel-data-dialog.component.html',
  styleUrls: ['./excel-data-dialog.component.css']
})
export class ExcelDataDialogComponent implements OnInit {
  dataSource = new MatTableDataSource<any>([]);
  tableObject: TableObject;
  constructor(
    public dialogRef: MatDialogRef<ExcelDataDialogComponent>,
    private notification: SnackBarService,
    public sharedService: SharedService,
    private excelService: ExcelService,
    @Inject(MAT_DIALOG_DATA)
    public data: DialogConfig,
  ) {
    let _cellDef: Array<cellDef> = [];
    _cellDef.push(new cellDef('srno', 'No.', false, InputType.Text, '', null, '', '', 0, true));
    if (!isNullOrEmptyOrUndefined(data) && !isNullOrEmptyOrUndefined(data.tableColumns)) {
      data.tableColumns.forEach(t => _cellDef.push(new cellDef(t.key, t.header, false, InputType.Text, '', null, '', '', 0, t.isDisplay)));
    }
    this.tableObject = new TableObject(_cellDef, 0, false, '', new CommonFilter(0, 5), CPOSEnum.None);
  }
  ngOnInit() { }
  validatdataSource(): boolean {
    return !this.dataSource || !this.dataSource.data || this.dataSource.data.length === 0;
  }
  downlodfile() {
    const header: Record<string, string>[] = [];
    this.data.tableColumns
      .filter(x => x.isExport === true)
      .forEach(t => header.push({ [t.header]: "" }));
    this.excelService.exportAsExcelFiles(header, this.data.fileDownloadName);
  }
  readExcelFile(e: any) {
    const file = e.target.files[0];
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    fileReader.onload = (event) => {
      const data = new Uint8Array(fileReader.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const headers = [];
      this.data.tableColumns.filter(t => t.isExport === true).forEach(t => headers.push(t.header));

      if (!validateHeaders(headers, worksheet)) {
        this.notification.error("Invalid Excel format! Please use the correct template.");
        return;
      }

      let tempcodelist = XLSX.utils.sheet_to_json(worksheet, { header: headers, range: 1 });
      tempcodelist = tempcodelist.filter(obj => {
        return Object.values(obj).some(value => value !== "");
      });

      if (isNullOrEmptyOrUndefined(tempcodelist) || tempcodelist.length == 0) {
        this.notification.error("Please add at least one row.");
        return;

      }
      const validationErrors = validateExcelData(tempcodelist, this.data.tableColumns);

      if (validationErrors.length > 0) {
        this.sharedService.getConfirmatonConfig(
          ConfirmationHeader.Warning,
          `<ul>${validationErrors}</ul>`,
          ButtonType.Ok
        );
        return;
      }
      this.dataSource.data = [];
      const transformedList = tempcodelist.map((item, index) => {
        const transformedItem: any = {};
        transformedItem.srno = index + 1;
        this.data.tableColumns.filter(x => x.isExport === true).forEach(column => {
          transformedItem[column.key] = item[column.header];
        });

        return transformedItem;
      });
      this.dataSource.data = transformedList;
    }
    e.target.value = null;
  }

  onCancel() {
    this.dialogRef.close();
  }
  onSave() {
      if (isNullOrEmptyOrUndefined(this.dataSource.data) || this.dataSource.data.length === 0) {
        this.notification.error("Please add at least one row.");
        return;
      }
      let dialogConfirmation: any;
      dialogConfirmation = this.sharedService.getConfirmatonConfig(ConfirmationHeader.Confirmation, 'Please click on Ok to proceed.', ButtonType.YesNo);
      dialogConfirmation.afterClosed().subscribe(result => {
        if (!isNullOrEmptyOrUndefined(result) && result === true) {
          let obj = this.dataSource.data.map(({ srno, ...rest }) => rest);
          this.sharedService.customPostApi(this.data.postApiUrl, {
            requestData: obj
          }).subscribe((t: any) => {
            if (t.status) {
              this.notification.success(t.message);
              this.dialogRef.close(true);
            }
            else {
              this.notification.error(t.message);
            }
          });
        }
      });
    }
}

// Checks if a value is a duplicate of a value already in the provided Set
function isDuplicate(value: any, uniqueValues: Set<string>): boolean {
  const key = isNullOrEmptyOrUndefined(value) ? '' : value.toString().trim().toLowerCase();
  if (uniqueValues.has(key)) {
    return true; // It's a duplicate
  }
  uniqueValues.add(key); // Add to the set for future checks
  return false;
}

function isNullOrEmptyOrUndefined(value: any): boolean {
  return value === null || value === '' || typeof value === 'undefined';
}
function getErrorMessage(columnRule: any, columnHeader: string, value?: any): string {
  if (columnRule.columnMessage) {
    return `<li>${columnRule.columnMessage}</li>`;
  }
  switch (columnRule.columnRule) {
    case 'required':
      return `<li>Value in '${columnHeader}' column cannot be empty.</li>`;
    case 'allowed_values':
      return `<li>Invalid value in '${columnHeader}' column. Allowed values are ${columnRule.criteria}.</li>`;
    case 'unique':
      return `<li>Value in '${columnHeader}' column must be unique.</li>`;
    default:
      return `<li>Invalid value in '${columnHeader}' column.</li>`;
  }
}
function validateExcelData(data: any[], columns: TableColumn[]): string[] {
  const validationErrors: string[] = [];
  const columnsToValidate = columns.filter(t => !isNullOrEmptyOrUndefined(t.validate));

  // Use a Set to track columns that already have a validation error
  const columnsWithError = new Set<string>();

  const uniqueValuesByColumn = new Map<string, Set<string>>();
  columnsToValidate.forEach(column => {
    const hasUniqueRule = column.validate.some(columnRule => columnRule.columnRule === 'unique');
    if (hasUniqueRule) {
      uniqueValuesByColumn.set(column.header, new Set<string>());
    }
  });

  // Outer loop: Iterate through each column with validation rules
  columnsToValidate.forEach(column => {
    // This loop will stop as soon as it finds a single error in this column
    data.some((row: any) => {
      const value = row[column.header];

      // Loop through each validation rule for the current column
      const hasError = column.validate.some((validationRule: any) => {
        let ruleIsInvalid = false;
        switch (validationRule.columnRule) {
          case 'required':
            ruleIsInvalid = (isNullOrEmptyOrUndefined(value) || value === '');
            break;
          case 'allowed_values':
            const allowedValues = validationRule.criteria as string[];
            ruleIsInvalid = !isNullOrEmptyOrUndefined(value) && !allowedValues.includes(value.toString().trim().toLowerCase());
            break;
          case 'unique':
            const uniqueValues = uniqueValuesByColumn.get(column.header)!;
            ruleIsInvalid = isDuplicate(value, uniqueValues);
            break;
        }

        if (ruleIsInvalid) {
          // Check if an error for this column has been added before
          if (!columnsWithError.has(column.header)) {
            const message = getErrorMessage(validationRule, column.header, value);
            validationErrors.push(message);
            columnsWithError.add(column.header);
          }
        }
        return ruleIsInvalid;
      });
      // If the innermost loop found an error, this loop returns true to stop
      return hasError;
    });
  });

  return validationErrors;
}
function validateHeaders(expected: string[], worksheet: any): boolean {
  const rows: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
  if (!rows.length) return false;
  const uploadedHeaders = (rows[0] as string[])
    .map(h => String(h || "").trim().toLowerCase())
    .sort();
  const expectedHeadersSorted = expected
    .map(h => h.trim().toLowerCase())
    .sort();
  return uploadedHeaders.length === expectedHeadersSorted.length && uploadedHeaders.every((val, idx) => val === expectedHeadersSorted[idx]);
}
/*~~~~~~~~~~~~~~~~~ Tushar 2025-09-15 Gid.:1345(CPOS)*/